import { CircularProgress } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { productSelector } from "../redux/slices/productSlice";
import searchIcon from "../../src/assets/img/icon404.png";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Icon } from "@iconify/react";
import { VideoPlayModal } from "./VideoPlayModal";
import { authSelector } from "../redux/slices/authSlice";
import { Link, useLocation } from "react-router-dom";
import useWindowWidth from "../hooks/useWindowWidth";
import EmptyState from "../portals/admin/components/EmptyState";
import { isClientPreview } from "../utils/clientPreview";
import { UsendLoadingMark } from "./loader/UsendMarks";
import styles from "./notFound.module.css";

export default function NotFound({
  margin,
  hide,
  loading,
  content,
  subContent,
  liveVideoUrl,
}) {
  const { loggedUser } = useSelector(authSelector);
  const { user } = loggedUser;
  const { isLoading } = useSelector(productSelector);
  const videoUrl = `https://u-send.s3.eu-west-2.amazonaws.com/videos/${
    content === "products"
      ? "products"
      : content === "disputes"
      ? "Dispute+list"
      : content === "trackings"
      ? "Order+tracking"
      : content
  }.mov`;

  const windowWidth = useWindowWidth()
  const location = useLocation().pathname

  if (user?.role === "admin") {
    return <EmptyState loading={loading || isLoading} content={content} />;
  }

  // Client preview: a quiet empty state with one clear next step. Video guides are
  // replaced by the page tours, so they are left out here.
  if (isClientPreview()) {
    if (loading || isLoading) {
      return (
        <div className={styles.empty} role="status" aria-label="Loading">
          <UsendLoadingMark size={32} />
        </div>
      );
    }
    const text = content === "orders" ? `Orders with status "${subContent}" show up here.` : subContent;
    return (
      <div className={styles.empty}>
        <span className={styles.tile} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 8.5 12 3.5 3 8.5v7l9 5 9-5z" />
            <path d="M3 8.5l9 5 9-5M12 13.5v7" />
          </svg>
        </span>
        <h3 className={styles.title}>No {content || "results"} found</h3>
        {!hide && text && <p className={styles.text}>{text}</p>}
        {!hide && content === "products" && (
          <Link to="/customer/products/live-products" className={styles.action}>
            Go to live products
          </Link>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: `${margin ? margin : "20%"} 0`,
      }}
    >
      <p>
        {loading || isLoading ? (
          <CircularProgress />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ marginBottom: "10px" }}>
              <img src={searchIcon} alt="" height="100" />
            </div>
            <p
              style={{
                fontSize: windowWidth <= 1500 ? "18px":"1.6em",
                fontWeight: "700",
                color: "black",
                lineHeight: 0.5,
              }}
            >
              No {content || "matched"} found
            </p>
            {!hide && user?.role !== "admin" && (
              <>
                <p
                  style={{
                    fontWeight: "600",
                    color: "black",
                    fontSize: windowWidth <= 1500 ? "12px":"14px",
                  }}
                >
                  {content === "orders"
                    ? `Only orders with status "${subContent}" will show up here`
                    : subContent}
                </p>
                <Stack
                  sx={{
                    ".MuiButtonBase-root": {
                      borderRadius: "16px",
                      padding: "0 30px",
                      textTransform: "capitalize",
                      fontWeight: 700,
                      marginTop: "10px",
                    },
                  }}
                  direction={windowWidth <1400 ?  "column": "row"}
                  spacing={3}
                >
                  {content === "products" && (
                    <Link to={`/customer/products/live-products`}>
                      <Button
                        // onClick={() =>
                        //   window.open(
                        //     `/customer/products/live-products`,
                        //     "_blank"
                        //   )
                        // }
                        sx={{
                          "&.MuiButtonBase-root": {
                            backgroundColor: "#8D40FF",
                          },
                        }}
                        variant="contained"
                        startIcon={
                          <Icon
                            icon="fluent-mdl2:product"
                            color="#ffffff"
                            width="20"
                            height="20"
                          />
                        }
                      >
                        Live Products
                      </Button>
                    </Link>
                  )}
                  {content !== "returned orders" && location !=="/customer/dashboard" && (
                    <VideoPlayModal
                      notFound
                      videoUrl={liveVideoUrl ? liveVideoUrl : videoUrl}
                    />
                  )}
                </Stack>
              </>
            )}
          </div>
        )}
      </p>
    </div>
  );
}
